import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
interface Slide4Props {
  onNext: () => void;
  onBack: () => void;
}
export function Slide4({
  onNext,
  onBack
}: Slide4Props) {
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." progress={{
    current: 1,
    total: 3
  }} onBack={onBack} data-id="element-143">
      <div className="w-full max-w-7xl mx-auto grid grid-cols-12 gap-12 items-center" data-id="element-144">
        <div className="col-span-7 space-y-6" data-id="element-145">
          <h1 className="text-4xl font-bold text-white mb-4 uppercase" data-id="element-146">
            ONE ANTIBODY. <span className="text-highlight italic" data-id="element-147">TWO</span>{' '}
            TARGETS.
          </h1>

          <div className="space-y-6" data-id="element-148">
            <div data-id="element-149">
              <p className="text-lg text-white font-bold uppercase mb-2" data-id="element-150">
                FARICIMAB IS A BISPECIFIC ANTIBODY DESIGNED TO BIND AND
                NEUTRALISE:¹
              </p>
              <ul className="space-y-2 text-lg text-white font-bold pl-4" data-id="element-151">
                <li className="flex items-center" data-id="element-152">
                  <span className="w-2 h-0.5 bg-white mr-3" data-id="element-153"></span>
                  <span data-id="element-154">VEGF-A</span>
                </li>
                <li className="flex items-center" data-id="element-155">
                  <span className="w-2 h-0.5 bg-white mr-3" data-id="element-156"></span>
                  <span data-id="element-157">ANGIOPOIETIN-2 (Ang-2)</span>
                </li>
              </ul>
            </div>

            <div data-id="element-158">
              <p className="text-lg text-white font-bold uppercase mb-2" data-id="element-159">
                Ang-2 & VEGF-A ACT SYNERGISTICALLY TO INCREASE:¹
              </p>
              <ul className="space-y-2 text-lg text-white font-bold pl-4" data-id="element-160">
                <li className="flex items-center" data-id="element-161">
                  <span className="w-2 h-0.5 bg-white mr-3" data-id="element-162"></span>
                  <span data-id="element-163">VASCULAR PERMEABILITY</span>
                </li>
                <li className="flex items-center" data-id="element-164">
                  <span className="w-2 h-0.5 bg-white mr-3" data-id="element-165"></span>
                  <span data-id="element-166">INFLAMMATION</span>
                </li>
                <li className="flex items-center" data-id="element-167">
                  <span className="w-2 h-0.5 bg-white mr-3" data-id="element-168"></span>
                  <span data-id="element-169">PATHOLOGICAL ANGIOGENESIS</span>
                </li>
              </ul>
            </div>

            <p className="text-base text-white/90 italic leading-snug pt-2" data-id="element-170">
              Targeting both pathways addresses mechanisms contributing to
              vascular instability.
            </p>
          </div>

          <div className="pt-4" data-id="element-171">
            <Button variant="primary" onClick={onNext} data-id="element-172">
              SEE HOW IT WORKS
            </Button>
          </div>
        </div>

        <div className="col-span-5 flex items-center justify-center" data-id="element-173">
          <div className="relative w-full h-96" data-id="element-174">
            <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-175">
              {/* Top Circles */}
              <div className="flex items-center gap-16 mb-16" data-id="element-176">
                <div className="flex flex-col items-center relative" data-id="element-177">
                  <div className="w-24 h-24 rounded-full bg-[#0E8585] text-white flex items-center justify-center font-bold text-lg shadow-lg z-10" data-id="element-178">
                    VEGF-A
                  </div>
                  <div className="absolute top-20 w-1 h-32 bg-[#0E8585]" data-id="element-179"></div>
                </div>
                <div className="flex flex-col items-center relative" data-id="element-180">
                  <div className="w-24 h-24 rounded-full bg-[#0E8585] text-white flex items-center justify-center font-bold text-lg shadow-lg z-10" data-id="element-181">
                    Ang-2
                  </div>
                  <div className="absolute top-20 w-1 h-32 bg-[#0E8585]" data-id="element-182"></div>
                </div>
              </div>

              {/* Middle Circle */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-40 h-40 border-4 border-[#C8B84D] rounded-full flex flex-col items-center justify-center bg-white shadow-xl z-20 mt-4" data-id="element-183">
                <span className="text-[#1B3A5C] font-bold text-center text-lg leading-tight" data-id="element-184">
                  Single
                  <br data-id="element-185" />
                  Antibody
                </span>
              </div>

              {/* Bottom Box */}
              <div className="w-64 h-32 bg-[#1B3A5C] rounded-xl flex items-end justify-center pb-6 text-white font-bold text-xl text-center shadow-xl mt-8 z-10" data-id="element-186">
                Instability
              </div>
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}